import './productListCarousel.scss';

import React, { forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Grid, Carousel } from '../base';
import useWindowSize from '../hooks/useWindowSize';

const ProductListCarousel = forwardRef((props, ref) => {
  const totalSlides = props.products.length;
  const [visibleSlides, setVisibleSlides] = useState(1);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    setVisibleSlides(isMobile ? 1 : 4);
  }, [isMobile]);

  const className = classNames({
    'carousel-products': true,
    [props.className]: props.className,
  });

  return (
    <Carousel
      ref={ref}
      className={className}
      totalSlides={totalSlides}
      isPlaying={totalSlides > visibleSlides}
      infinite
      visibleSlides={visibleSlides}
    >
      <Carousel.Slider>
        {props.products.map((product, index) => (
          <Carousel.Slide key={product.id} index={index} className="item">
            {props.renderItem(product, index)}
          </Carousel.Slide>
        ))}
      </Carousel.Slider>
      {totalSlides > visibleSlides && (
        <Grid.Row className="mx-0">
          <Grid.Col className="col">
            <Carousel.DotGroup />
          </Grid.Col>
        </Grid.Row>
      )}
    </Carousel>
  );
});

ProductListCarousel.propTypes = {
  products: PropTypes.array,
  renderItem: PropTypes.func,
  className: PropTypes.string,
};

export default ProductListCarousel;
